import { ArrowUpRight, MapPin, Phone } from "lucide-react";

const stores = [
  {
    id: "01",
    name: "Khatipura",
    address:
      "17, Behind Maharaja Complex, Khatipura, Indore, Madhya Pradesh - 452007",
  },
  {
    id: "02",
    name: "Old Palasia",
    address:
      "1B, Ground Floor, The Mark, 20-A, Anand Bazar Road, Opposite Rafael Tower, Old Palasia, Indore, Madhya Pradesh - 452001",
  },
  {
    id: "03",
    name: "Vijay Nagar",
    address:
      "PU-4, Opposite Prestige College, Near Bombay Hospital, Scheme No. 54, Vijay Nagar, Indore, Madhya Pradesh - 452010",
  },
  {
    id: "04",
    name: "Annapurna Road",
    address:
      "2, Annapurna Road, Opposite Dussehra Maidan, Bank Colony, Indore, Madhya Pradesh - 452009",
  },
  {
    id: "05",
    name: "Scheme No. 140",
    address:
      "Shop No. 8, No. 09, RCM Block, Shanti Dazzle, Near Agrawal Public School, Scheme No. 140, Indore, Madhya Pradesh - 452016",
  },
];

const PHONE_NUMBER = "+919539188888";

const StoreLocations = () => {
  return (
    <section aria-labelledby="store-locations-title">
      <div className="mb-4 flex items-center justify-between gap-3">
        <div>
          <h2 id="store-locations-title" className="text-xl font-semibold">
            Our Stores
          </h2>
          <p className="mt-1 text-sm text-[#A3A3A3]">Indore, Madhya Pradesh</p>
        </div>
        <span className="text-sm text-[#A3A3A3]">05 branches</span>
      </div>

      <div className="grid grid-cols-1 gap-x-6 gap-y-5 sm:grid-cols-2">
        {stores.map((store) => (
          <div key={store.id} className="min-w-0 border-b border-[#292929] pb-4">
            <div className="flex items-start gap-2">
              <MapPin aria-hidden="true" size={15} className="mt-0.5 shrink-0 text-red-500" />
              <div className="min-w-0">
                <h3 className="text-sm font-medium text-white">{store.name}</h3>
                <p className="mt-1 text-xs leading-5 text-[#AFAFAF]">{store.address}</p>
              </div>
            </div>
            <div className="mt-2 flex items-center gap-4 pl-[23px]">
              <a
                href={`tel:${PHONE_NUMBER}`}
                className="inline-flex items-center gap-1.5 text-xs text-[#D4D4D4] transition-colors hover:text-white"
                aria-label={`Call ${store.name} branch at +91 95391 88888`}
              >
                <Phone aria-hidden="true" size={12} className="text-red-500" />
                +91 95391 88888
              </a>
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                  `${store.address}, India`
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-xs font-medium text-red-500 transition-colors hover:text-red-300"
                aria-label={`Find ${store.name} on Google Maps`}
              >
                Directions
                <ArrowUpRight aria-hidden="true" size={13} />
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StoreLocations;
